<template>
  <div class="pa1-l flex justify-center items-center body relative hide-child w-100 h-100">
    <span v-show="track !== currentTrack" @click="changeTrack(track)"
          class="white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer">
      <font-awesome-icon icon="play" size="2x"/>
    </span>
    <img class="mw-100 h-100" :src="picture">
    <img class="track-picture-vinyl vinyl-rotation absolute top-50 left-50 z-2 w-90 w-80-ns"
         v-show="track == currentTrack && isPlaying" src="../../assets/vinyl-record.svg"
         alt="playing track">
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'

  export default {
    name: 'track-image',
    props: {
      track: {
        required: true
      }
    },
    components: {
      FontAwesomeIcon
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack',
        'isPlaying'
      ]),
      picture () {
        let trackPicture = ''
        if (!/\/uploads\/tracks\//.test(this.track.picture)) {
          trackPicture = '/uploads/tracks/' + this.track.picture
        } else { trackPicture = this.track.picture }
        return consts.MEDIA_BASE_URL + trackPicture
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'changeTrack'
      ])
    }

  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .track-picture-vinyl {
    max-width: inherit;
    max-height: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackImage.vue